// 创建文件zh.js
const zh = {
    admin: '后台管理系统',
    test: '你好',
    reach:'至',
    upperLimit:'上限',
    lowerLimit:'下限',
    language: {
        zh: '中文',
        en: 'English',
    }
}
export default zh;
